export class NSReqHeader 
{
    VERSION()
    {
        return `ns-site-version`;
    }
}